import React from "react";
import { useLoading } from "../services/providers/loading.context";

const LoadingSpinner = () => {
  const { isLoading } = useLoading();
  //   console.log("IS LOADING", isLoading);

  return (
    isLoading && (
      <div className="loading-overlay">
        <div className="spinner"></div>
        <p className="ml-3">Loading....</p>
      </div>
    )
  );
};

export default LoadingSpinner;
